import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store/configureStore';
import AuthedBreadcrumb from './authedBreadcrumb';
import { accountPageList, userPageList } from 'const';

class Breadcrumb extends Component {
  render() {
    var routes = [];
    var ii;
    for (ii in accountPageList) {
      routes.push(<Route exact key={accountPageList[ii]} path={accountPageList[ii]} component={AuthedBreadcrumb} />);
    }
    for (ii in userPageList) {
      routes.push(<Route exact key={userPageList[ii]} path={userPageList[ii]} component={AuthedBreadcrumb} />);
    }
    return (
      <ConnectedRouter history={history}>
        <Switch>
          {/* 管理者アカウント系画面かユーザー系画面であれば管理者アカウントのパンくずリストを表示 */}
          {routes}
        </Switch>
      </ConnectedRouter>
    );
  }
}

export default Breadcrumb;
